// Show one invitation per visit after ten visible seconds, including an arrival
// on an interior page. Typing only defers it; it never marks the offer as seen.
export function initContactPopup(dialog, doc = document, environment = {}) {
  if (!dialog || typeof dialog.showModal !== 'function') return;
  const win = doc.defaultView ?? globalThis;
  const schedule = environment.setTimeout ?? setTimeout;
  const cancel = environment.clearTimeout ?? clearTimeout;
  const now = environment.now ?? (() => performance.now());
  let storage;
  try { storage = environment.storage ?? win.sessionStorage; } catch {}
  const read = key => { try { return storage?.getItem(key); } catch { return null; } };
  const write = (key, value) => { try { storage?.setItem(key, String(value)); } catch {} };
  const autoOpenDelay = 10000;
  const seenKey = 'soltis-price-match-invitation-v2';
  const elapsedKey = 'soltis-price-match-visible-ms-v2';
  let seen = read(seenKey) === 'seen';
  let elapsed = Math.min(autoOpenDelay, Math.max(0, Number(read(elapsedKey)) || 0));
  let startedAt;
  let timer;
  let pageHidden = false;
  let opener;
  const stopClock = () => {
    cancel(timer);
    timer = undefined;
    if (startedAt !== undefined) elapsed = Math.min(autoOpenDelay, elapsed + Math.max(0, now() - startedAt));
    startedAt = undefined;
    write(elapsedKey, elapsed);
  };
  const remember = () => { stopClock(); seen = true; write(seenKey, 'seen'); };
  const open = source => {
    if (dialog.open) return;
    opener = source ?? doc.activeElement;
    dialog.showModal();
    doc.documentElement.classList.add('has-contact-popup');
    remember();
  };
  const close = () => { if (dialog.open) dialog.close(); };
  const clock = () => {
    stopClock();
    if (seen || doc.hidden || pageHidden) return;
    if (elapsed >= autoOpenDelay) {
      // Avoid interrupting a visitor who is already using a form or menu.
      if (doc.activeElement?.closest?.('input,textarea,select,[contenteditable="true"]') || doc.querySelector('.locations-menu[open],.site-nav[data-nav-open="true"],dialog[open]')) {
        timer = schedule(clock, 1000);
        return;
      }
      open();
      return;
    }
    startedAt = now();
    timer = schedule(clock, autoOpenDelay - elapsed);
  };
  dialog.querySelector('.contact-close').addEventListener('click', close);
  dialog.addEventListener('close', () => {
    doc.documentElement.classList.remove('has-contact-popup');
    if (opener?.isConnected) opener.focus({preventScroll:true});
  });
  let backdropPress = false;
  dialog.addEventListener('pointerdown', event => { backdropPress = event.target === dialog; });
  dialog.addEventListener('click', event => {
    if (backdropPress && event.target === dialog) close();
    backdropPress = false;
  });
  doc.addEventListener('click', event => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest?.('a[data-contact-open]');
    if (!link || dialog.contains(link)) return;
    event.preventDefault();
    open(link);
  });
  doc.querySelectorAll('.lead-form, .s-location-form, .s-contact-form, form[action*="/contact"]').forEach(form => {
    form.addEventListener('submit', () => {
      remember();
      const status = form.querySelector('.form-status');
      if (status) status.textContent = 'Continuing securely to Soltis SEO…';
      // Native navigation posts to the existing Shopify form. Shopify owns
      // CAPTCHA, validation and confirmation; no simulated success or fetch.
    });
  });
  doc.addEventListener('visibilitychange', clock);
  win.addEventListener?.('pagehide', () => { pageHidden = true; stopClock(); });
  win.addEventListener?.('pageshow', () => {
    pageHidden = false;
    seen = seen || read(seenKey) === 'seen';
    elapsed = Math.max(elapsed, Math.min(autoOpenDelay, Math.max(0, Number(read(elapsedKey)) || 0)));
    clock();
  });
  if (dialog.querySelector('[data-contact-result]') && win.location?.hash === '#contact-popup-form') open();
  else clock();
}
